import React from 'react';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" data-id="element-555">
      <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-556">
        <div className="sticky top-0 bg-gray-900 border-b border-gray-700 p-6 flex justify-between items-center" data-id="element-557">
          <h2 className="text-2xl font-bold text-white" data-id="element-558">
            Política de Privacidad
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" aria-label="Close" data-id="element-559">
            <XIcon className="h-6 w-6" data-id="element-560" />
          </button>
        </div>
        <div className="p-6 text-gray-300 space-y-4" data-id="element-561">
          <section data-id="element-562">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-563">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-564">
              Recopilamos información personal que usted nos proporciona
              directamente, como su nombre, dirección de correo electrónico y
              otra información de contacto cuando se registra para nuestros
              servicios o eventos.
            </p>
          </section>
          <section data-id="element-565">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-566">
              2. Uso de la Información
            </h3>
            <p data-id="element-567">
              Utilizamos la información recopilada para proporcionarle acceso a
              nuestros servicios, enviarle comunicaciones relacionadas con
              eventos, y mejorar nuestros servicios.
            </p>
          </section>
          <section data-id="element-568">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-569">
              3. Compartir Información
            </h3>
            <p data-id="element-570">
              No vendemos, alquilamos ni compartimos su información personal con
              terceros, excepto cuando sea necesario para proporcionar nuestros
              servicios o cuando lo exija la ley.
            </p>
          </section>
          <section data-id="element-571">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-572">
              4. Seguridad
            </h3>
            <p data-id="element-573">
              Implementamos medidas de seguridad apropiadas para proteger su
              información personal contra acceso no autorizado, alteración o
              destrucción.
            </p>
          </section>
          <section data-id="element-574">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-575">
              5. Sus Derechos
            </h3>
            <p data-id="element-576">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal. Para ejercer estos derechos, contáctenos en
              support@truemarketer.com.
            </p>
          </section>
          <section data-id="element-577">
            <h3 className="text-xl font-semibold text-white mb-2" data-id="element-578">
              6. Contacto
            </h3>
            <p data-id="element-579">
              Si tiene preguntas sobre esta política de privacidad, contáctenos
              en{' '}
              <a href="mailto:support@truemarketer.com" className="text-red-500 hover:text-red-400" data-id="element-580">
                support@truemarketer.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>;
}